import { render, staticRenderFns } from "./KernelChartWrapper.vue?vue&type=template&id=701ee6a8&"
import script from "./KernelChartWrapper.vue?vue&type=script&lang=js&"
export * from "./KernelChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports